export default __webpack_public_path__ + "static/media/160-600.d4c53380.png";